import { createRefetchContainer, graphql } from 'react-relay';
import Search from './SearchComponent';

export default createRefetchContainer(Search,
  {
    viewer: graphql`
      fragment SearchContainer_viewer on User
      @argumentDefinitions(
        count: { type: "Int", defaultValue: 3 },
        query: { type: "String!", defaultValue: "" }
      ) {
        s_time_zone
        user_event_search(first: 3, query: $query) {
          edges{
            node{
              event {
                id
                title
              }
              booking_status
              start_at
              end_at
              user_event_segments(first: 1){
                edges{
                  node{
                    location
                  }
                }
              }
            }
          }
        }
      }`
  },
  graphql`
    query SearchContainerRefetchQuery($query: String!) {
      viewer {
        ...SearchContainer_viewer @arguments(query: $query)
      }
    }
  `
);



// WEBPACK FOOTER //
// ./webpack/components/App/SearchContainer.js